export default __webpack_public_path__ + "static/media/oneDrive.3c8005aa.svg";